import React, { useEffect } from 'react';
import Clarity from '@microsoft/clarity';
import NewHeroSection from '../Organism/NewHeroSection';
import NewFeatureSection from '../Organism/NewFeatureSection';
import NewPowerFeatureSection from '../Organism/NewPowerFeatureSection';
import NewToolsSkillsSection from '../Organism/NewToolsSkillsSection';
import NewTestimonialSection from '../Organism/NewTestimonialSection';
import NewFooter from '../Organism/Footer/NewFooter';
import Intergrationring from '../Organism/Integrationrings';
import BookDemoButton from '../Organism/BookDemoButton'; // new

const NewHomepage = () => {
  useEffect(() => {
    Clarity.init('uia7piv6pq');
  }, []);

  return (
    <>
      <NewHeroSection />
      <NewFeatureSection />
      <NewToolsSkillsSection />
      <NewPowerFeatureSection />
      <NewTestimonialSection />
      <Intergrationring />
      <NewFooter />
      <BookDemoButton /> 
    </>
  );
};

export default NewHomepage;